<template>
  <div>
    <div class="header-login">
      <b-container fluid class="container-header">
        <img class="logo-login" src="../Img/mq_logo.svg" alt="Money Quiz logo">
        <b-row>
          <b-col cols="12">
            <b-col cols="12" class="app-title-login" v-html="$t('login_app_name')"></b-col>
            <b-col cols="12" class="app-desc-login">{{ $t("login_app_desc") }}</b-col>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container>
      <b-form @submit.prevent="login()">
        <b-row>
          <b-col cols="12">
            <b-col cols="12" class="title-login" tabindex="1">{{ $t("login") }}</b-col>
          </b-col>
          <b-col cols="12" class="mt-3">
            <b-alert :show="hasError" class="error-message" >
              <div class="error-title">{{ serviceError }}</div>
              <span class="error-subtitle">{{ serviceErrorDetail }}</span>
              <span v-if="hasErrorEmailNoConfirmed" class="error-subtitle">
                {{ $t("error_email_not_confirmed_1") }}
                <a href="#" @click='sendConfirmationEmail()'>{{ $t("error_email_not_confirmed_2") }}</a>
              </span>
            </b-alert>
          </b-col>
          <b-col cols="12">
            <b-col cols="12" class="mt-3">
              <label for="email" class="label-login">{{ $t("your_email") }}</label>
              <input id="email" type="text" class="input-login" placeholder="name@domain.com"
                     v-model="form.email" value="" tabindex="2">
              <span v-if="emailError" class="form-error">{{ $t("error_required_field") }}</span>
            </b-col>
          </b-col>
          <b-col cols="12">
            <b-col cols="12 mt-1">
              <label for="password" class="label-login">{{ $t("password") }}</label>
              <input id="password" type="password" class="input-login"
                     :placeholder="$t('password_placeholder')" v-model="form.password"
                     value="" tabindex="3">
              <span v-if="passwordError" class="form-error">{{ $t("error_required_field") }}</span>
            </b-col>
          </b-col>
          <b-col cols="12">
            <b-col cols="12" class="mt-4">
              <b-button block variant="primary" type="submit" tabindex="4" :disabled="isDisabled">
                {{ $t("login_button") }}
              </b-button>
            </b-col>
          </b-col>
          <b-col cols="12" class="mt-4 text-center cursor-pointer">
            <div v-on:keyup.enter.space="routeToForgotPassword"
                 v-on:click="routeToForgotPassword" tabindex="5">
              <span class="purple-text">{{ $t("forgot_password") }}</span>
            </div>
          </b-col>
          <b-col cols="12" class="mt-4 mb-4 text-center">
            <div v-on:keyup.enter.space="routeToRegister"
                 v-on:click="routeToRegister" tabindex="6">
              <span class="grey-text"> {{ $t("dont_have_account") }} </span>
              <span class="purple-text cursor-pointer">{{ $t("register_login") }}</span>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <b-col cols="12" class="mt-3">
        <hr class="separator-text">
      </b-col>
      <b-col cols="12" class="mt-2 mb-4">
        <b-button block variant="primary-inverse" v-on:keyup.enter.space="routeToGuest"
                  @click="routeToGuest">
          {{ $t("enter_as_guest") }}
        </b-button>
      </b-col>
      <legal-message />
    </b-container>
  </div>
</template>

<script>
  import { AuthService, UserService } from '../Services'
  import LegalMessage from "../Components/LegalMessage"
  import validateForms from '../../../core/Mixins/validate-forms'
  import { Storage } from '../../../core/Utils'

  export default {
    name: 'Login',
    components: { LegalMessage },
    mixins: [validateForms],
    data() {
      return {
        form: {email: "", password: ""},
        emailError: false,
        passwordError: false,
        serviceError: null,
        serviceErrorDetail: false,
        hasError: false,
        hasErrorEmailNoConfirmed: false,
        isDisabled: false,
        isGuest: false,
        loadPage: false,
      }
    },
    methods: {
      login() {
        const email = this.form.email
        const password = this.form.password
        this.emailError = email === ""
        this.passwordError = password === ""
        this.hasError = false;
        this.hasErrorEmailNoConfirmed = false
        this.serviceError = null
        this.serviceErrorDetail = false

        if (email && password && this.isValidform()) {
          this.isDisabled = true;
          AuthService.login(email, password).then(() => {
            this.$router.push({name: 'Welcome'})
          }).catch(err => {
            this.isDisabled = false;
            this.hasError = true;
            this.serviceError = this.$t("error_unexpected")
            if (err) {
              if (err.message && err.message === 'Email_No_Confirmed') {
                this.serviceError = this.$t("error_email_not_verified")
                this.serviceErrorDetail = ''
                this.hasErrorEmailNoConfirmed = true
              } else {
                this.serviceError = this.$t("error_invalid_credentials")
                this.serviceErrorDetail = this.$t("error_invalid_credentials_details")
                this.hasErrorEmailNoConfirmed = false
              }
            }
          })
        }
      },
      routeToGuest(){
        Storage.removeGuest()
        this.isGuest = true;
        Storage.setGuest({isGuest: this.isGuest})
        this.$router.push({name: 'Welcome'})
      },
      routeToRegister(){
        this.$router.push({name: 'Register'})
      },
      routeToForgotPassword(){
        this.$router.push({name: 'ForgotPassword'})
      },
      sendConfirmationEmail() {
        const email = this.form.email
        this.emailError = email === ""
        this.hasError = false;
        this.hasErrorEmailNoConfirmed = false
        this.serviceError = null
        this.serviceErrorDetail = false

        if (email && this.isValidform()) {
          this.isDisabled = true;
          UserService.sendConfirmationEmail(email).then(response => {
            if (response.message === 'Parent_Consent_Required') {
              if (response.parentConsentRequired) {
                this.$router.push({ name: 'ParentConsentRequired', params: { userId: response.user.id } })
              } else {
                this.$router.push({name: 'VerifyParentEmail'})
              }
            } else {
              this.$router.push({name: 'VerifyEmail'})
            }
          }).catch(err => {
            this.isDisabled = false;
            this.hasError = true;
            this.serviceError = this.$t("error_unexpected")
            if (err) {
              this.serviceErrorDetail = this.$t("error_invalid_credentials_details")
              this.hasErrorEmailNoConfirmed = false
            }
          })
        }
      }
    }
  }
</script>
<style scoped lang="stylus">
  @import "../Styles/security_styles.styl"

  .input-login
    width: 100%
    border-radius: 8px

  .label-login
    color #5E4FB2

  .header-login
    background transparent linear-gradient(180deg, #8149A5 0%, #5E4FB2 100%) 0% 0% no-repeat padding-box

  .app-title-login
    margin-top 35px
    font font-roboto-bold
    font-size 28px
    color white

  .app-desc-login
    margin-top 5px
    margin-bottom 15px
    font font-opensans
    font-size 13px
    color white

  .title-login
    font font-roboto-bold
    font-size 22px
    color black
    margin-top 40px

  .logo-login
    position absolute
    top 10px
    right 10px
    width 94px
    height 58px

  .separator-text
    border: 0
    border-top: 1px solid #BFBFBF
    height: 1px
    overflow: visible
    padding: 0
    color: #000000
    text-align: center

  .separator-text::after
    content: "or"
    display: inline-block
    position: relative
    top: -0.9em
    font-size: 15px
    padding: 0 0.3em
    background color-white

  .cursor-pointer
    cursor: pointer

  @media (min-width: 576px)
   .container-header
     max-width: 540px

  @media (min-width: 768px)
    .container-header
      max-width: 720px
    .logo-login
      width 131px
      height 81px
    .app-title-login
      margin-top 10px
      font-size 35px
    .app-desc-login
      margin-top 1px
      margin-bottom 10px
      padding-right 105px
      font-size 14px
    .title-login
      font-size 27px

  @media (min-width: 992px)
    .container-header
      padding-left 85px
    .logo-login
      right 27px
    .header-login
      min-height 100px
    .container-header
      max-width: 100%
    .title-login
      font-size 30px
    .app-desc-login
      padding-right 160px
</style>
